import { useState } from 'react';
import { useStableRect } from '@elfsight/widget-utils';

export function useResizeWidth() {
  const [width, setWidth] = useState(0);
  const [measureRef] = useStableRect({ width }, ({ width }) => setWidth(width));

  return { measureRef, width };
}
